import React from 'react';
import _ from 'lodash';

import {isDefaultAppLayout} from '@/env';
import DefaultAppLayoutWrapper from './DefaultAppLayoutWrapper';
import FlowAppLayoutWrapper from './FlowAppLayoutWrapper';
import {getLayout} from '@/util/AuthStore';

/**
 * 本应用支持两种布局，配置项位于 .env REACT_APP_LAYOUT
 *
 * 默认布局（default）：每个模块的菜单位于左侧
 * 流式布局（flow）：每个模块菜单位于 header 的菜单中
 *
 * @return {JSX.Element}
 * @constructor
 */
function AppLayoutWrapper() {
    // const layout = _.get(authStore, 'isDefaultAppLayout');
    const layout = getLayout();
    if (layout) {
        return <DefaultAppLayoutWrapper />;
    }
    return <FlowAppLayoutWrapper />;
}

export default AppLayoutWrapper;
